import { Component, Input, OnInit } from '@angular/core';
import { ChartOfAccountsService } from '../chart-of-accounts.service';
import { ChartOfAccounts } from '../chart-of-accounts';
import { NotificationService } from '../../../shared/notification.service';
import { SelectComparisons } from '../../../shared/pipes/select.comparisons';

@Component({
  selector: 'app-chart-of-accounts-select',
  templateUrl: 'select.component.html',
})
export class ChartOfAccountsSelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the chartOfAccounts to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the delivery-methods currently loaded.
   *
   * @type {ChartOfAccounts[]}
   */
  public chartOfAccounts: ChartOfAccounts[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ChartOfAccountsService} chartOfAccountsService
   * @param {NotificationService} notificationService
   */
  constructor(
    private chartOfAccountsService: ChartOfAccountsService,
    private notificationService: NotificationService,
  ) {
    super();
    this.chartOfAccountsService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the chartOfAccounts list.
   */
  public ngOnInit(): void {
    this.loadChartOfAccounts(1, 10000);
  }

  /**
   * Loads a list of delivery-methods using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadChartOfAccounts(page?: number, limit?: number): void {
    const listChartOfAccounts = this.chartOfAccountsService
      .listChartOfAccounts(page, limit)
      .subscribe((chartOfAccounts: ChartOfAccounts[]) => {
        this.chartOfAccounts = chartOfAccounts;
        listChartOfAccounts.unsubscribe();
      });
  }
}
